import { createGlobalStyle } from 'styled-components';

export const IMAGE_INTENT_ATTRIBUTE = 'data-image-intent';

// Stops the iOS long-press save sheet ("Save to Photos", "Copy", "Copy
// Subject") on every element that carries the save-intent handlers
// (useImageIntentFriction and attachImageIntentListeners add the attribute).
// Mobile Safari fires no event the page could cancel before that sheet opens,
// so CSS is the only way to stop it — cancelling dragstart alone does not —
// and the long-press is still logged by the touch timer, which this rule does
// not affect. Verified in Mobile Safari (iOS 18): the sheet opens without this
// rule and does not open with it, both on an <img> and on a container around
// one (`-webkit-touch-callout` inherits).
//
// Only marked elements match. A zoomed child photo is marked by
// useImageIntentZoomContent; stock artwork in the same zoom library is not, so
// it keeps the normal long-press behaviour.
//
// Mounted by Root.js only for a studio whose save blocking is on
// (isSaveBlockingEnabled; off by default).
//
// `any-pointer` rather than `pointer`: an iPad with a trackpad attached still
// has a touchscreen. The rule only matters for touch long-presses; desktops
// with no touchscreen never match, so their text selection is untouched.
const ImageIntentTouchStyle = createGlobalStyle`
  @media (any-pointer: coarse) {
    [${IMAGE_INTENT_ATTRIBUTE}] {
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      user-select: none;
    }
  }
`;

export default ImageIntentTouchStyle;
